import { render, staticRenderFns } from "./ModalObject.vue?vue&type=template&id=1aa715ec"
import script from "./ModalObject.vue?vue&type=script&lang=js"
export * from "./ModalObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports